<template>
  <div
    class="bg-static-default-low flex items-center justify-start overflow-hidden px-16 transition-all duration-300 ease-in-out md:px-32"
    :class="{
      'py-0 opacity-0': hidden,
      'py-20 opacity-100': !hidden,
      'sticky top-0 z-10': isAlwaysSticky,
      'md:sticky md:top-0': !isAlwaysSticky,
    }"
  >
    <TheLogo v-if="!hidden" class="h-12 md:h-16 lg:h-20" />
  </div>
</template>

<script lang="ts" setup>
import TheLogo from './TheLogo.vue'

defineProps<{
  hidden?: boolean
  isAlwaysSticky?: boolean
}>()
</script>
